import { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { copy } from "shared/assets";
import { IAPIState, IStatus } from "shared/types";
import { Spacer } from "shared/layout";
import { Card, Loader, Message } from "shared/components";

import { BAND_PATHS } from "Bands/router";
import {
  clearActionMeta,
  createEventScheduleBlock,
  dataMetaSelector,
  dispatchGetEventScheduleBlocks,
} from "Bands/state";
import { BAND_ACTIONS } from "Bands/types";
import { useEventContext } from "Bands/contexts";
import { useBandRoute, useClearActionMetaOnUnMount } from "Bands/utils";

const { scheduleBlock: scheduleBlockCopy } = copy;

export const CreateScheduleBlockPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { getPath } = useBandRoute();
  const { api: apiMeta, id: blockId } = useSelector(
    dataMetaSelector(BAND_ACTIONS.createEventScheduleBlock)
  );

  const { eventId, eventPath } = useEventContext();

  useClearActionMetaOnUnMount(BAND_ACTIONS.createEventScheduleBlock);

  // create a new schedule block as soon as this page mounts
  useEffect(() => {
    if (!eventPath) return;

    dispatch(
      createEventScheduleBlock({
        title: scheduleBlockCopy.title,
        event: eventPath,
      })
    );
  }, [dispatch, eventPath]);

  useEffect(() => {
    if (!blockId || !eventId) return;

    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(clearActionMeta(BAND_ACTIONS.createEventScheduleBlock));

      dispatchGetEventScheduleBlocks(dispatch, eventId);

      history.replace(
        getPath(BAND_PATHS.EDIT_SCHEDULE_BLOCK, {
          params: { eventId, blockId },
        })
      );
    }
  }, [dispatch, apiMeta, blockId, eventId, getPath, history]);

  const renderContent = useMemo(() => {
    switch (apiMeta?.status) {
      case IAPIState.pending:
        return (
          <Spacer size="s" align="center">
            <Loader size="l" />
            <p>{scheduleBlockCopy.create.messages.adding}</p>
          </Spacer>
        );
      case IAPIState.failed:
        return <Message message={copy.errors.general} status={IStatus.error} />;
      case IAPIState.succeeded:
        return (
          <Message message={scheduleBlockCopy.create.messages.success} status={IStatus.success} />
        );
      default:
        break;
    }
  }, [apiMeta?.status]);

  return <Card title={scheduleBlockCopy.create.messages.adding}>{renderContent}</Card>;
};
